import { logout, getUserByToken, getTenantTypeByToken } from '@/api/user'
import { getToken, setToken, removeToken, setCurrentOrganizationId, setFirstCommunityId, getCurrentOrganizationId } from '@/utils/auth'
import { permissionCommunityDropList, getCurrentStaffOrganizationDropList } from '@/api/dropList'
import { companyInfo } from '@/api/public'
import { resetRouter } from '@/router'
import router from '@/router'
import store from '@/store'

const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    tenant: '',
    avatar: '',
    userId: '',
    userInfo: '',
    mobilePhone: '',
    departmentId: '',
    tenantId: '',
    organizationInfo: {
      organizationName: '',
      organizationId: '',
      organizationType: '',
      organizationLevel: '',
      createNum: '',
      buildingRoomNumber: '',
    },
    sealConfig: {
      companyLogo: '',
      companyName: '',
    },
    companyPermissionCommunityLists: '',
    subsidiaryLists: '',
    currentOrganizationId: '',
    firstCommunityId: '',
    companyModifyCommunityLists: '',
    personnelOrganization: '',
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: state => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
    setToken(token)
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_TENANT: (state, tenant) => {
    state.tenant = tenant
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_USERID: (state, id) => {
    state.userId = id
  },
  SET_PERSONNELORGANIZATION: (state, id) => {
    state.personnelOrganization = id
  },
  SET_USERINFO: (state, info) => {
    state.userInfo = info
  },
  SET_MOBILEPHONE: (state, mobilePhone) => {
    state.mobilePhone = mobilePhone
  },
  SET_ORGANIZATION: (state, organization) => {
    state.organizationInfo = organization
  },
  SET_DEPARTMENTID: (state, departmentId) => {
    state.departmentId = departmentId
  },
  SET_TENANTID: (state, tenantId) => {
    state.tenantId = tenantId
  },
  SET_SEALCONFIG: (state, sealConfig) => {
    state.sealConfig = sealConfig
  },
  SET_COMPANYPERMISSIONCOMMUNTIY: (state, value) => {
    state.companyPermissionCommunityLists = value
  },
  SET_COMPANYMODIFYCOMMUNTIY: (state, value) => {
    state.companyModifyCommunityLists = value
  },
  SET_SUBSIDIARYDROPLISTS: (state, value) => {
    state.subsidiaryLists = value
  },
  SET_CURRENTORGANIZATIONID: (state, value) => {
    setCurrentOrganizationId(value)
    state.currentOrganizationId = value
  },
  SET_FIRSTCOMMUNITYID: (state, value) => {
    setFirstCommunityId(value)
    state.firstCommunityId = value
  },
}

const actions = {
  // 获取用户信息
  getInfo({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      getUserByToken()
        .then(response => {
          if (response.errCode !== 0) {
            resolve(response.errMsg)
          }
          if (response.data === null) resolve(response)
          const {
            realName,
            avatarPath,
            userId,
            mobilePhone,
            personnelOrganization,
            organizationId,
            organizationLevel,
            organizationName,
            groupPermission,
            organizationType,
            createNum,
            buildingRoomNumber,
            departmentId,
            tenantId,
          } = response.data
          commit('SET_NAME', realName)
          commit('SET_AVATAR', avatarPath)
          commit('SET_USERID', userId)
          commit('SET_MOBILEPHONE', mobilePhone)
          commit('SET_USERINFO', response.data)
          commit('SET_PERSONNELORGANIZATION', personnelOrganization)
          commit('SET_ORGANIZATION', {
            organizationName: organizationName,
            organizationId: organizationId,
            organizationType: organizationType,
            groupPermission: groupPermission,
            organizationLevel: organizationLevel,
            createNum: createNum,
            buildingRoomNumber: buildingRoomNumber,
          })
          commit('SET_DEPARTMENTID', departmentId)
          commit('SET_TENANTID', tenantId)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  //根据token获取租户类型
  getTenantTypeBy({ commit }) {
    return new Promise((resolve, reject) => {
      getTenantTypeByToken()
        .then(response => {
          if (response.errCode !== 0) {
            resolve(response.errMsg)
          }
          if (response.data === null) resolve(response)
          const tenant = response.data
          commit('SET_TENANT', tenant)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取公章配置
  getSealConfig({ commit }) {
    return new Promise((resolve, reject) => {
      companyInfo({ id: store.getters.currentOrganizationId || getCurrentOrganizationId() })
        .then(response => {
          if (response.errCode !== 0) {
            resolve(response.errMsg)
          }
          if (response.data === null) resolve(response)
          const { companyLogo, companyName } = response.data
          commit('SET_SEALCONFIG', {
            companyLogo: companyLogo,
            companyName: companyName,
          })
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 获取权限项目
  getPermissionCommunityList({ commit }, params = {}) {
    return new Promise((resolve, reject) => {
      permissionCommunityDropList({
        ...params,
        token: getToken('token'),
      })
        .then(response => {
          if (response.errCode !== 0) {
            resolve(response.errMsg)
          }
          if (response.data === null) resolve(response)

          if (params.isFirst) {
            commit('SET_FIRSTCOMMUNITYID', response.data && response.data.length ? response.data[0].communityId : '')
            if (params.reload) {
              // 刷新当前页面
              const { fullPath } = router.currentRoute
              router.replace({
                path: '/redirect' + fullPath,
              })
            }
          }
          if (params.organizationId) {
            params.isModify ? commit('SET_COMPANYMODIFYCOMMUNTIY', response.data) : commit('SET_COMPANYPERMISSIONCOMMUNTIY', response.data)
          }

          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 获取子公司下拉列表
  getSubsidiaryDropLists({ commit, dispatch, state }) {
    return new Promise((resolve, reject) => {
      getCurrentStaffOrganizationDropList()
        .then(response => {
          if (response.errCode !== 0) {
            resolve(response.errMsg)
          }
          if (response.data === null) resolve(response)
          commit('SET_SUBSIDIARYDROPLISTS', response.data)
          if (response.data.length) {
            const item = response.data.find(item => item.organizationId === state.organizationInfo.organizationId)
            const currentOrganizationId = getCurrentOrganizationId()

            let selectedOrganizationId
            if (currentOrganizationId) {
              const hasCurrentOrganization = response.data.some(item => item.organizationId === currentOrganizationId)

              selectedOrganizationId = hasCurrentOrganization ? currentOrganizationId : item ? item.organizationId : response.data[0].organizationId
            } else {
              selectedOrganizationId = item ? item.organizationId : response.data[0].organizationId
            }

            commit('SET_CURRENTORGANIZATIONID', selectedOrganizationId)

            dispatch('getPermissionCommunityList', {
              organizationId: selectedOrganizationId,
              isFirst: true,
            })
          }
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 用户登出
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      logout()
        .then(() => {
          removeToken() // must remove  token  first
          resetRouter()
          commit('RESET_STATE')
          resolve()
          store.commit('permission/SET_ROUTESCUT', 0)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 删除 token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      resetRouter()
      commit('RESET_STATE')
      resolve()
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
